import type { RenderInClientHeaderSignature } from '@efdigital/ll-addon-content/types/components/parts/render-in-client-header';
import type { TemplateOnlyComponent } from '@ember/component/template-only';

const RenderInClientHeader: TemplateOnlyComponent<RenderInClientHeaderSignature> =
  <template>
    <div class="va-program-client-header" ...attributes>{{yield}}</div>
  </template>;

export { RenderInClientHeader };
